import script from "./FormWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./FormWrapper.vue?vue&type=script&setup=true&lang=js"

import "./FormWrapper.vue?vue&type=style&index=0&id=0dcae7d5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dcae7d5"]])

export default __exports__